<template>
	<v-storyblok-story :story="story ?? undefined" />
</template>

<script setup lang="ts">
import {useStoryblokStory} from "@pkg/shared/composables/use-storyblok-story";

const {t} = useI18n({useScope: "global"});
const config = useRuntimeConfig();

const {
	data: {value: story},
} = await useStoryblokStory(t("storyblok.home"));

useJsonld({
	"@context": "https://schema.org",
	"@type": "WebSite",
	name: "Masku",
	alternateName: t("site.name"),
	url: config.public.appUrl,
});

const siteTitle = t("masku-url");

useSeoMeta({
	title: story?.content.meta?.title || story?.name,
	titleTemplate(title) {
		return title || siteTitle;
	},
	ogTitle: story?.content.meta?.title ?? story?.name,
	description: story?.content.meta?.description ?? undefined,
	ogDescription: story?.content.meta?.description ?? undefined,
});
</script>
